export default __webpack_public_path__ + "static/media/Path 2587.5dfe1672.svg";